import { createApp } from 'vue'
import { createPinia } from 'pinia'

import NaviContainer from '@/modules/navi'
import nativeOnBack from '@/modules/navi_v2/utils/on_back_helper'

const mountElement = document.querySelector('#navi-app')
const desktopBreakpoint = parseInt(mountElement.dataset.desktopBreakpoint || '1024', 10)
const shouldShowSearchPanel = mountElement.dataset.shouldShowSearchPanel !== 'false'
const onBackUrl = mountElement.dataset.onBackUrl
const useNativeOnBack = mountElement.dataset.nativeOnBack

const naviApp = createApp(NaviContainer, {
  desktopBreakpoint,
  shouldShowSearchPanel,
  onBackUrl,
  onBackHandler: (
    useNativeOnBack === 'true'
      ? () => nativeOnBack({ fallbackUrl: onBackUrl })
      : null
  ),
})
naviApp.use(createPinia())
naviApp.mount(mountElement)
